import { withStyles } from '@material-ui/core/styles';
import React, { useState, useMemo } from 'react';
import {
  Button,
  Datagrid,
  TextField,
  TopToolbar,
  linkToRecord,
  ReferenceField,
  List
} from 'react-admin';
import BulkActionDeleteButton from '../../../core/components/BulkActionDeleteButton';
import Empty from '../../../core/components/list/Empty';
import AddRolesDialog from './AddRolesDialog';

const UserRolesActionStyles = {
  addButton: {
    border: '1px solid #E0E0E0',
    background: '#FFFFFF',
    marginLeft: '10px'
  }
};

const UserRolesAction = withStyles(
  UserRolesActionStyles
)(({ classes, hasWriteUserRolePermission, ...props }) => (
  <TopToolbar>
    {hasWriteUserRolePermission && (
      <Button
        color="primary"
        onClick={props.handleAddUserRolesButtonClick}
        label="Add Access Role"
        className={classes.addButton}
        disableFocusRipple
        id="add-access-role"
      />
    )}
  </TopToolbar>
));

const FeatureAccessControlTab = props => {
  const [open, setOpen] = useState(false);

  const handleDialogClose = () => setOpen(false);
  const handleDialogToggle = () => setOpen(!open);

  const { classes, permissions } = props;
  const userId = props.id;

  const { hasWriteUserRolePermission, hasReadRolePermission } = useMemo(() => {
    return {
      hasWriteUserRolePermission: permissions.includes('AUTH_WRITE_USER_ROLE'),
      hasReadRolePermission: permissions.includes('AUTH_READ_ROLE_NA')
    };
  }, [permissions]);

  return (
    <>
      <List
        style={{ margin: '0px', width: '100%' }}
        pagination={false}
        className={classes.gridTab}
        basePath="/userroles"
        resource="userroles"
        filter={{ userId }}
        title=" "
        actions={
          <UserRolesAction
            userId={userId}
            handleAddUserRolesButtonClick={() => setOpen(!open)}
            hasWriteUserRolePermission={hasWriteUserRolePermission}
          />
        }
        bulkActionButtons={
          hasWriteUserRolePermission && (
            <BulkActionDeleteButton
              confirmTitle="Remove Access role"
              confirmContent="You will be removing the selected Access Roles for this user. Are you sure you want to proceed ?"
              label="Remove"
            />
          )
        }
        empty={
          <Empty
            emptyText="There are no Access Roles to be displayed"
            title="Access Roles"
            buttons={[
              {
                label: 'Add Access Role',
                onClick: handleDialogToggle,
                hide: !hasWriteUserRolePermission
              }
            ]}
          />
        }
      >
        <Datagrid>
          <ReferenceField
            label="Access Role Name"
            source="roleId"
            reference="roles"
            sortable={false}
            link={
              hasReadRolePermission
                ? record => `${linkToRecord(`/roles`, record.roleId)}`
                : false
            }
          >
            <TextField source="description" id={'access-role-name'} />
          </ReferenceField>
          <TextField
            source="roleId"
            label="Access Role ID"
            sortable={false}
            id={'access-role-id'}
          />
        </Datagrid>
      </List>
      <AddRolesDialog userId={userId} open={open} onClose={handleDialogClose} />
    </>
  );
};

export default FeatureAccessControlTab;
